
<ng-container *ngIf="!genericErrorMessage; else errorTemplate">
  <div style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(0,0,0,.72); backdrop-filter: saturate(180%) blur(10px); z-index: 9999; display: block;"></div>
  <div class="reveal-modal rs-reveal-modal-loading open" role="alert" style="visibility: visible;">
    <div class="rs-spinner-neg"
         aria-live="polite"
         [attr.aria-label]="'products.overview.loadingCta.label' | translate"
         title="Loading"
         aria-busy="true"></div>
    <div class="rs-modal-content">
      {{ 'products.overview.loadingCta.label' | translate }}
    </div>
  </div>
</ng-container>

<ng-template #errorTemplate>
  <px-alert
    [alerts]="[
    {
      type: 'error',
      description: 'get-jwt.error.notReturnUrl' | translate,
      isClosable: true,
      useNegativeColors: false
    }
  ]"
    *ngIf="genericErrorMessage">
  </px-alert>
</ng-template>
